import { GetServerSidePropsContext } from "next";
import getApolloClientOrigin from "../utils/getApolloClientOrigin";
import { HttpLink, ApolloClient, InMemoryCache, concat } from "@apollo/client";

import errorLink from "../utils/errorLink";

/** Creates a brand new instance of ApolloClient
 * ---
 * NOTE: in most cases you should use `getOrCreateApolloClient()` instead to
 * fetch the ApolloClient singleton if it's already created.
 */

function createNewApolloClient(context?: GetServerSidePropsContext) {
  const origin = getApolloClientOrigin(context);

  // HttpLink to our local graphql BFF
  const localGqlLink = new HttpLink({
    credentials: "include",
    uri: `${origin}/api/pricing/graphql`,
    headers: context?.req?.headers?.cookie
      ? { cookie: context.req.headers.cookie }
      : {},
  });

  const ssrMode = typeof window === "undefined";
  return new ApolloClient({
    ssrMode,
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            planStacks: {
              keyArgs: ["accountId"],
            },
          },
        },
      },
    }),
    link: concat(errorLink, localGqlLink),
    name: "pricing-page",
    version: "1.0",
  });
}

export default createNewApolloClient;
